var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tagList.length==0)?_c('div',[_c('span',[_vm._v("-")])]):_c('div',{staticClass:"Tags",staticStyle:{"font-size":"0"}},_vm._l((_vm.tagList),function(item,index){return _c('span',{key:index,class:{
        comStatus: true,
        comWarn: _vm.checkEntstatus(item.tagText),
        comGreen: ['005'].includes(item.categoryCode),
        comBlue: ['003', '004', '006', '008','009'].includes(item.categoryCode),
        comOrange: ['007'].includes(item.categoryCode),
        comTaxation: ['002'].includes(item.categoryCode)
    }},[_vm._v(_vm._s(item.tagText))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f79a0a44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/loader.js!./src/components/global/tags.vue
// module id = jKXW
// module chunks = 30